import ProjectTable from '@/components/DynamicComponents/Projects/ProjectTable'
import Filters from '@/components/DynamicComponents/Projects/Filters'
import { dateComparator } from '@/services/api'
import { projectAPIs } from '@/services/authConstantsV1'

export default {
  components: {
    Filters,
    ProjectTable,
  },
  data() {
    return {
      columns: [
        {
          headerName: 'Client ID',
          field: 'clientId',
          width: 80,
          headerTooltip: 'Client ID',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'restoreProject' },
        },
        {
          headerName: 'Project #',
          field: 'projectNumber',
          width: 80,
          headerTooltip: 'Project #',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'restoreProject' },
        },
        {
          headerName: 'Project Name',
          field: 'projectName',
          width: 120,
          headerTooltip: 'Project Name',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'restoreProject' },
        },
        {
          headerName: 'Entity Name',
          field: 'entityName',
          width: 80,
          headerTooltip: 'Entity Name',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'restoreProject' },
        },
        {
          headerName: 'Project Staff Engineer',
          field: 'projectStaffEngineer',
          width: 100,
          headerTooltip: 'Project Staff Engineer',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'restoreProject' },
        },
        {
          headerName: 'Project Manager',
          field: 'projectManager',
          width: 100,
          headerTooltip: 'Project Manager',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'restoreProject' },
        },
        {
          headerName: 'Project Reviewer',
          field: 'projectReviewer',
          width: 100,
          headerTooltip: 'Project Reviewer',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'restoreProject' },
        },
        {
          headerName: 'City',
          field: 'city',
          width: 80,
          headerTooltip: 'City',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'restoreProject' },
        },
        {
          headerName: 'State',
          field: 'state',
          width: 80,
          headerTooltip: 'State',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'restoreProject' },
        },
        {
          headerName: 'SF Percent Complete',
          field: 'percentComplete',
          width: 80,
          headerTooltip: 'SF Percent Complete',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            type: 'dashboardProject',
            name: 'percentComplete',
          },
        },
        {
          headerName: 'Time Spent',
          field: 'timeSpent',
          width: 80,
          headerTooltip: 'Total Time Spent In Project',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            type: 'dashboardProject',
            name: 'timeSpent',
          },
        },
        {
          headerName: 'Created Date',
          field: 'createdDate',
          comparator: dateComparator,
          width: 120,
          headerTooltip: 'Created Date',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'restoreProject', name: 'createdDate' },
        },
        {
          headerName: 'Updated Date',
          field: 'updatedDate',
          comparator: dateComparator,
          width: 120,
          headerTooltip: 'Updated Date',
          cellRenderer: 'toolTipRenderer',
          sort: 'desc',
          cellRendererParams: { type: 'restoreProject', name: 'updatedDate' },
        },
        {
          headerName: 'Action',
          field: 'action',
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          sortable: false,
          editable: false,
          cellRenderer: 'actionCellRenderer',
          floatingFilter: false,
          width: 70,
          resizable: false,
          cellRendererParams: { type: 'Restore Project' },
          suppressSizeToFit: true,
          toolPanelClass: 'hide-column',
          pinned: 'right',
        },
      ],
      headStyle: {
        'font-weight': 'bold',
        background: 'transparent !important',
        color: '#000000d9 !important',
        padding: '0 4px !important',
      },
      url: projectAPIs.project.list,
    }
  },
}
